var _defs, _g, _path, _path2, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasty3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    zoomAndPan: "magnify",
    viewBox: "0 0 120 119.999999",
    height: 160,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dfe6e63ef1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.878906 89 L 100.378906 89 L 100.378906 95.738281 L 20.878906 95.738281 Z M 20.878906 89 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d18b1734b0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 57 19.988281 L 63 19.988281 L 63 49 L 57 49 Z M 57 19.988281 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dfe6e63ef1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ef782e",
    d: "M 97.273438 89.0625 L 24.316406 89.0625 C 22.421875 89.0625 20.886719 89.828125 20.886719 90.773438 C 20.886719 90.78125 20.890625 90.785156 20.894531 90.789062 L 27.878906 95.917969 C 27.886719 95.925781 27.902344 95.929688 27.914062 95.929688 L 90.527344 95.929688 C 90.539062 95.929688 90.550781 95.925781 90.558594 95.921875 L 100.488281 90.8125 C 100.496094 90.808594 100.5 90.804688 100.5 90.796875 L 100.5 90.675781 C 100.5 89.785156 99.054688 89.0625 97.273438 89.0625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ef782e",
    d: "M 28.457031 86.375 C 29.777344 72.902344 43.707031 62.304688 60.695312 62.304688 C 77.683594 62.304688 91.613281 72.902344 92.933594 86.375 L 92.984375 86.375 C 93.019531 85.878906 93.039062 85.382812 93.039062 84.882812 C 93.039062 71.019531 79.722656 59.675781 62.878906 58.769531 C 63.203125 58.078125 63.390625 57.234375 63.390625 56.320312 C 63.390625 54.011719 62.183594 52.140625 60.695312 52.140625 C 59.207031 52.140625 57.996094 54.011719 57.996094 56.320312 C 57.996094 57.234375 58.1875 58.078125 58.507812 58.769531 C 41.664062 59.675781 28.351562 71.019531 28.351562 84.882812 C 28.351562 85.382812 28.371094 85.878906 28.40625 86.375 L 28.457031 86.375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef782e",
    d: "M 64.535156 42.601562 C 64.875 47.835938 68.542969 53.125 68.542969 53.125 C 66.941406 49.042969 66.765625 45.757812 66.914062 43.480469 C 67.289062 37.789062 69.910156 35.066406 68.792969 30.953125 C 68.027344 28.136719 65.925781 26.234375 64.277344 25.070312 C 65.078125 25.925781 66.238281 27.394531 66.789062 29.453125 C 68.144531 34.5 64.152344 36.761719 64.535156 42.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef782e",
    d: "M 50.4375 42.601562 C 50.777344 47.835938 54.445312 53.125 54.445312 53.125 C 52.84375 49.042969 52.667969 45.757812 52.816406 43.480469 C 53.1875 37.789062 55.8125 35.066406 54.695312 30.953125 C 53.929688 28.136719 51.828125 26.234375 50.179688 25.070312 C 50.980469 25.925781 52.136719 27.394531 52.691406 29.453125 C 54.046875 34.5 50.054688 36.761719 50.4375 42.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d18b1734b0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ef782e",
    d: "M 57.789062 37.523438 C 58.128906 42.757812 61.796875 48.042969 61.796875 48.042969 C 60.195312 43.960938 60.019531 40.679688 60.167969 38.398438 C 60.542969 32.710938 63.164062 29.984375 62.046875 25.875 C 61.28125 23.054688 59.179688 21.152344 57.53125 19.988281 C 58.332031 20.84375 59.492188 22.316406 60.042969 24.371094 C 61.398438 29.417969 57.40625 31.679688 57.789062 37.523438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasty3);
export default __webpack_public_path__ + "static/media/tasty3.79f58b3fffcadec7395aace038d51c74.svg";
export { ForwardRef as ReactComponent };